import {alpha, Divider, Grid, List, ListItem, ListItemButton, Skeleton} from "@mui/material";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import {RootState, useAppSelector} from "../../../store";
import {getRandomNumber} from "../../../util/utils";
import {FC} from "react";
import Box from "@mui/material/Box";
import Badge from "../../shared/badge/Badge";
import {useTheme} from "@mui/material/styles";
import ScrollFader from "../../shared/scroll-fader/ScrollFader";
import {getRandomCitiesArray} from "../../../store/wish/Helper";
import useCitiesByCountry, {ValidCountries} from "../../../util/hooks/useCitiesByCountry";

interface Props {
    selectedCity: string
    handleChangeCity: (id: string) => void
}

const CitySidebar: FC<Props> = (props) => {
    const {t, i18n} = useTranslation()
    const cities = useAppSelector((state: RootState) => state.wishReducer.citiesWithCounts)
    const citiesLoading = useAppSelector((state: RootState) => state.wishReducer.citiesWithCountsLoading)
    const citiesArray = citiesLoading ? getRandomCitiesArray() : cities
    const theme = useTheme()
    const {cities: citiesConst} = useCitiesByCountry(ValidCountries.MACEDONIA)

    return (
        <Box mt={4}>
            <Typography variant='h5' color="primary" fontWeight={600} mt="4px">{t('city')}</Typography>
            <Divider sx={{
                height: "2px",
                width: '100%',
                backgroundColor: alpha(theme.palette.primary.main, .5),
                mt: 2.5,
                mb: 1
            }}/>
            <ScrollFader faderSize={70} deps={[citiesArray]}>
                <List sx={{maxHeight: 320}}>
                    {citiesArray.map((city) => (
                        <ListItemButton key={city.id}
                                        disabled={city.count === 0}
                                        sx={{p: 0, cursor: city.count !== 0 ? 'cursor' : 'default'}}
                                        selected={city.id === props.selectedCity}
                                        onClick={() => city.count !== 0 ? props.handleChangeCity(city.id) : {}}>
                            <ListItem sx={{py: `12px !important`}}>
                                <Grid container justifyContent="space-between" alignContent="center" flexWrap="nowrap"
                                      gap={1}>
                                    <Typography variant="body1" color="primary"
                                                fontWeight={city.id === "all" ? 600 : undefined}>
                                        {citiesLoading ?
                                            <Skeleton animation='wave' width={`${getRandomNumber(80, 150)}px`}/> :
                                            // @ts-ignore
                                            city.id === "all" ? t("all_cities") : citiesConst[city.city]?.[i18n.language] ?? citiesConst["Skopje"][i18n.language]}
                                    </Typography>
                                    <Box sx={{alignSelf: 'center'}}>
                                        {citiesLoading ?
                                            <Skeleton variant='circular' animation='pulse' width='20px'/> :
                                            <Badge content={city.count}/>}
                                    </Box>
                                </Grid>
                            </ListItem>
                        </ListItemButton>
                    ))}
                </List>
            </ScrollFader>
        </Box>
    )
}

export default CitySidebar
